// Lib
import chroma from 'chroma-js';

// Note: this is pretty much a duplicate of getIsLightColor from coreColorUtil.ts
// We need to include this in here because of the monorepo structure meaning
// that we can't easily share code between the web app and the design system.
// Keep these defaults in sync with Milanote card contrast logic in src/client/element/card/Card.jsx.

const DARK_TEXT_COLOR = '#3d4554';
const LIGHT_TEXT_COLOR = '#ffffff';

/**
 * Determines if the colour is light or dark based on the contrast of the Milanote card text colours on top of them.
 */
export const isLightBackgroundColor = (color: string): boolean => {
    try {
        // calculate expected contrast ratio of light text or dark text
        const contrastDarkText = chroma.contrast(DARK_TEXT_COLOR, color);
        const contrastLightText = chroma.contrast(LIGHT_TEXT_COLOR, color);

        // then use the highest contrast version
        return contrastDarkText > contrastLightText;
    } catch (e) {
        // If the colour isn't valid then we'll just assume it's light
        return true;
    }
};
